import { defineSlotRecipe } from "@chakra-ui/react";

export const formFieldRecipe = defineSlotRecipe({
  className: "gf-form-field",
  slots: ["root", "label", "helper", "error"],

  base: {
    root: {
      display: "flex",
      flexDirection: "column",
      gap: "8px",
    },
    label: {
      fontFamily: "body",
      fontSize: "13px",
      fontWeight: "medium",
      color: "fg.default",
      letterSpacing: "-0.005em",
    },
    helper: {
      fontFamily: "body",
      fontSize: "12px",
      color: "fg.muted",
    },
    error: {
      fontFamily: "body",
      fontSize: "12px",
      color: "bg.danger",
    },
  },
});
